import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';
import memberList from './zh-TW/memberList';
import dashboard from './zh-TW/dashboard';
import register from './zh-TW/register';
import staff from './zh-TW/staff';
import store from './zh-TW/store';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.copyright.produced': '藍海科技工作室出品',
  'app.preview.down.block': '下載此頁面到本地項目',
  'app.welcome.link.fetch-blocks': '獲取全部區塊',
  'app.welcome.link.block-list': '基於 block 開發，快速構建標準頁面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...memberList,
  ...dashboard,
  ...register,
  ...staff,
  ...store,
  'pages.403.subTitle': '抱歉，您沒有訪問此頁面的權限。',
  'pages.403.back': '返回首頁',
  'menu.account.logout': '退出登錄',
  'menu.account.logout.confirm': '確認退出登錄',
  'menu.account.logout.confirm.content': '您確定要退出登錄嗎？',
  'menu.account.logout.success': '已成功退出登錄',
  'menu.account.logout.failed': '退出登錄失敗',
  
  'menu.account.changePassword': '修改密碼',
  'menu.account.changePassword.currentPassword': '當前密碼',
  'menu.account.changePassword.currentPassword.required': '請輸入當前密碼',
  'menu.account.changePassword.newPassword': '新密碼',
  'menu.account.changePassword.newPassword.required': '請輸入新密碼',
  'menu.account.changePassword.password.tooShort': '密碼長度不能少於6個字符',
  'menu.account.changePassword.confirmPassword': '確認新密碼',
  'menu.account.changePassword.confirmPassword.required': '請確認新密碼',
  'menu.account.changePassword.passwordMismatch': '兩次輸入的密碼不一致',
  'menu.account.changePassword.success': '密碼修改成功',
  'menu.account.changePassword.failed': '密碼修改失敗',
  'menu.account.changePassword.incorrectPassword': '當前密碼不正確',
  'pages.memberList.pagination.total': '共 {total} 條記錄',
  'pages.memberList.pagination.pageSize': '條/頁',
  'pages.memberList.pagination.jump': '跳至',
  'pages.memberList.pagination.page': '頁',
  
  // 禮品卡列表
  'pages.giftCardList.title': '禮品卡列表',
  'pages.giftCardList.create': '創建禮品卡',
  'pages.giftCardList.createVirtual': '創建虛擬禮品卡',
  'pages.giftCardList.createPhysical': '創建實體禮品卡',
  'pages.giftCardList.downloadPhysical': '批量下載實體卡號',
  'pages.giftCardList.code': '禮品卡編號',
  'pages.giftCardList.physicalCardNumber': '實體卡號',
  'pages.giftCardList.value': '禮品卡面值',
  'pages.giftCardList.initialAmount': '初始金額',
  'pages.giftCardList.balance': '剩餘餘額',
  'pages.giftCardList.balanceStatus': '餘額',
  'pages.giftCardList.balanceStatus.all': '全部禮品卡',
  'pages.giftCardList.balanceStatus.withBalance': '有餘額',
  'pages.giftCardList.balanceStatus.withoutBalance': '無餘額',
  'pages.giftCardList.status': '狀態',
  'pages.giftCardList.createTime': '創建時間',
  'pages.giftCardList.activeDate': '激活日期',
  'pages.giftCardList.activeBy': '激活人',
  'pages.giftCardList.activationStatus': '激活狀態',
  'pages.giftCardList.activationStatus.all': '全部禮品卡',
  'pages.giftCardList.activationStatus.active': '已激活',
  'pages.giftCardList.activationStatus.inactive': '未激活',
  'pages.giftCardList.expiryDate': '到期日期',
  'pages.giftCardList.validDays': '有效期（天）',
  'pages.giftCardList.actions': '操作',
  'pages.giftCardList.actions.details': '詳情',
  'pages.giftCardList.note': '備註',
  'pages.giftCardList.date': '日期範圍',
  'pages.giftCardList.refresh': '刷新',
  'pages.giftCardList.email': '電子郵箱',
  'pages.giftCardList.phone': '手機號碼',
  'pages.giftCardList.tempEmail': '臨時電子郵箱',
  'pages.giftCardList.tempPhone': '臨時手機號碼',
  'pages.giftCardList.contactInfo': '聯繫方式',
  'pages.giftCardList.search.infoType.placeholder': '請選擇聯繫方式',
  'pages.giftCardList.contactValue': '聯繫資訊',
  'pages.giftCardList.search.infoValue.placeholder': '請輸入聯繫資訊',
  'pages.giftCardList.createDate': '創建日期',
  
  'pages.giftCardList.search.code.placeholder': '請輸入禮品卡編號',
  'pages.giftCardList.search.cardNumber': 'Card ID / 實體卡號',
  'pages.giftCardList.search.status.placeholder': '請選擇狀態',
  'pages.giftCardList.search.date.start': '開始日期',
  'pages.giftCardList.search.date.end': '結束日期',
  'pages.giftCardList.search.submit': '搜索',
  'pages.giftCardList.search.reset': '重置',
  
  'pages.giftCardList.create.success': '禮品卡創建成功',
  'pages.giftCardList.create.error': '禮品卡創建失敗',
  'pages.giftCardList.create.value.required': '請輸入禮品卡面值',
  'pages.giftCardList.create.value.placeholder': '請輸入禮品卡面值',
  'pages.giftCardList.create.balance.required': '請輸入初始餘額',
  'pages.giftCardList.create.balance.placeholder': '請輸入初始餘額',
  'pages.giftCardList.create.initialAmount.required': '請輸入初始金額',
  'pages.giftCardList.create.initialAmount.placeholder': '請輸入初始金額',
  'pages.giftCardList.create.email.placeholder': '請輸入電子郵箱',
  'pages.giftCardList.create.phone.placeholder': '請輸入手機號碼',
  'pages.giftCardList.create.expiryDate.placeholder': '請選擇到期日期',
  'pages.giftCardList.create.validDays.required': '請輸入有效天數',
  'pages.giftCardList.create.validDays.placeholder': '請輸入有效天數',
  'pages.giftCardList.create.note.placeholder': '請輸入備註信息',
  'pages.giftCardList.physical.issuingStore': '發卡門店',
  'pages.giftCardList.physical.storeRequired': '請選擇發卡門店',
  'pages.giftCardList.physical.quantity': '數量',
  'pages.giftCardList.physical.batch': '創建批次',
  'pages.giftCardList.physical.allBatches': '全部實體禮品卡',
  'pages.giftCardList.physical.loadError': '載入實體禮品卡選項失敗',
  'pages.giftCardList.physical.createSuccess': '已創建 {count} 張實體禮品卡',
  'pages.giftCardList.physical.createError': '創建實體禮品卡失敗',
  'pages.giftCardList.physical.batchLoadError': '載入實體禮品卡批次失敗',
  'pages.giftCardList.physical.downloadError': '下載實體卡號失敗',
  
  'pages.giftCardList.level': '禮品卡類型',
  'pages.giftCardList.create.level.required': '請選擇禮品卡類型',
  'pages.giftCardList.create.level.placeholder': '請選擇禮品卡類型',
  'pages.giftCardList.error.headOffice': '無法獲取總部信息',
  'pages.giftCardList.error.fetchLevels': '獲取禮品卡類型失敗',
  'pages.giftCardList.error.storeId': '未找到門店ID',
  'pages.giftCardList.error.invalidStoreId': '門店ID格式不正確',
  'pages.giftCardList.error.fetchFailed': '獲取禮品卡列表失敗',
  'pages.giftCardList.error.fetchStoreFailed': '獲取門店信息失敗',
  'pages.giftCardList.error.noLevels': '未找到禮品卡等級配置，請先在管理後台創建禮品卡等級',
  
  'pages.giftCardList.status.active': '激活',
  'pages.giftCardList.status.inactive': '未激活',
  'pages.giftCardList.status.expired': '已過期',
  'pages.giftCardList.status.used': '已使用',
  'pages.giftCardList.status.cancelled': '已取消',
  
  'pages.giftCardList.pagination.total': '共 {total} 條記錄',
  'pages.giftCardList.pagination.pageSize': '條/頁',
  'pages.giftCardList.pagination.jump': '跳至',
  'pages.giftCardList.pagination.page': '頁',
  
  'app.common.cancel': '取消',
  'app.common.create': '創建',
  'pages.store.giftCardDetails.send.email': '發送郵件',
  'pages.store.giftCardDetails.send.phone': '發送簡訊',
  'pages.store.giftCardDetails.send.card': '發送卡片',
  'pages.store.giftCardDetails.send.wallet': '發送到錢包',
  'pages.store.giftCardDetails.email.placeholder': '請輸入電子郵箱',
  'pages.store.giftCardDetails.phone.placeholder': '請輸入手機號碼',
 
};
